const baseColumns = [
  {
    title: "Sr.No.",
    name: "index",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "center",
  },
  {
    title: "Outlet Name",
    name: "firmName",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "left",
  },
  {
    title: "Beat Name",
    name: "beatName",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "left",
  },
  {
    title: "Order No",
    name: "orderNo",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "center",
  },
  {
    title: "Order Date",
    name: "orderDate",
    positionCenter: false,
    showInscreen: true,
    alignCenter: "center",
  },
  {
    title: "Product Name",
    name: "productName",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "left",
  },
  {
    title: "UOM",
    name: "outletUom",
    positionCenter: false,
    showInscreen: true,
    alignCenter: "center",
  },
  {
    title: "Rate",
    name: "rate",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "right",
  },
];

const stockColumns = [
  {
    title: "Existing Stock",
    name: "secondaryClosingQty",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "right",
  },
  {
    title: "Remaining Stock",
    name: "productStock",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "right",
  },
];

const quantityColumns = [
  {
    title: "Order Qty",
    name: "billQty",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "right",
  },
  {
    title: "Bill Quantity",
    name: "orderQty",
    placeHolder: "Enter Bill Quantity",
    textFieldError: "percentageErr",
    error: "Percentage",
    textField: true,
    positionCenter: true,
    showInscreen: true,
    alignCenter: "right",
  },
  {
    title: "Total",
    name: "total",
    positionCenter: true,
    showInscreen: true,
    alignCenter: "right",
  },
];

const withStockColumns = [...baseColumns, ...stockColumns, ...quantityColumns];
const withoutStockColumns = [...baseColumns, ...quantityColumns];

/** Returns order table columns based on stock-calculation flag */
export const getOrderTableColumns = (withStock) =>
  withStock ? withStockColumns : withoutStockColumns;

export const NEGATIVE_PRODUCT_LIST_COLUMNS = [
  { name: "index", title: "Sr. No.", align: "center" },
  { title: "Outlet Name", name: "firmName", alignCenter: "left" },
  { title: "Beat Name", name: "beatName", alignCenter: "left" },
  { title: "Order No", name: "orderNo", align: "center" },
  { title: "Order Date", name: "orderDate", align: "center" },
  { name: "productName", title: "Product", align: "left" },
  { name: "outletUom", title: "UOM", align: "center" },
  { title: "Order Qty", name: "billQty", align: "right" },
];
